import { Content } from "@/ui/Content";
import { getInsights } from "@/functions/getInsights";
import * as additionalComponents from "@/components/AwardsPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const insights = getInsights().filter((i) => ("tags" in i ? i.tags.includes("Awards") : false));

  const routerProp = router["about.awards"];
  const titleKey = "page.awards.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "AwardsPageBannerSection", props: { className: "" } },
        { component: "AwardsPageTextSection", props: { className: "py-4 pt-md-5 pb-md-0" } },
        { component: "AwardsPageFeedSection", props: { className: "py-4 pt-md-0 pb-md-5" } },
        {
          component: "InsightsSection",
          props: {
            className: "py-4 py-md-5",
            title: { path: "page.awards.insights.title" },
            items: insights,
          },
        },
        { component: "GallerySection", props: { pathPrefix: "page.awards.gallery" } },
      ],
    },
  };
}
